/* ===========================================================
   📁 constants.js
   Global sabitler — Proje isimleri, bayrakları ve zone eşleşmeleri
   =========================================================== */

export const PROJECTS = [

  { name: "Survivor Turkey", flag: "https://flagcdn.com/w80/tr.png" },
  { name: "Exatlon Mexico", flag: "https://flagcdn.com/w80/mx.png" },
  { name: "Exatlon Greece", flag: "https://flagcdn.com/w80/gr.png" },
  { name: "Survivor Germany", flag: "https://flagcdn.com/w80/de.png" },
  { name: "Exatlon Germany", flag: "https://flagcdn.com/w80/de.png" },
  { name: "Survivor Croatia Serbia", flag: "https://flagcdn.com/w80/hr.png" },
  { name: "Exatlon Telemundo", flag: "https://flagcdn.com/w80/us.png" },
  { name: "Survivor Czech Slovak", flag: "https://flagcdn.com/w80/cz.png" },
  { name: "Survivor Greece", flag: "https://flagcdn.com/w80/gr.png" },
  { name: "Survivor Romania", flag: "https://flagcdn.com/w80/mx.png" },
  { name: "Darts Party", flag: "https://flagcdn.com/w80/de.png" },
  { name: "La Isla Telemundo", flag: "https://flagcdn.com/w80/us.png" },
  { name: "Survivor Mexico", flag: "https://flagcdn.com/w80/mx.png" },

];

/* ===========================================================
   📍 Zone → Locations
   =========================================================== */
export const ZONES = {
  "ZONE 1": [
    "SPEED",
    "CONTAINER/TRAIN CRASH",
    "CROSSFIT",
    "EXA-ARENA",
    "MONEYWALL",
    "BLACK BOX",
    "UNDER CONSTRUCTION",
    "SLUDGE RUN",
    "ANDRE'S LAND",
    "KONSEY - QUIZ",
    "MAD MAX",
    "OLYMPIC",
    "OPENAIR COUNCIL",
    "DUEL AREA",
    "MINE - LIMITLESS",
    "AMPHIBIOUS",
  ],
  "ZONE 2": [
    "GATO 1",
    "IRON GATO 1-2",
    "SURVIVOR ARENA",
    "GATITO ON THE RIVER",
    "GATITO GAME ZONE",
    "GATITO 1",
    "GATITO 2",
    "MINI RIVER 1",
    "MINI RIVER 2",
    "MINI RIVER 3",
    "MINI RIVER JUNGLE",
    "MINI RIVER RIVER RUN",
    "GATO 2 - 1 (ZIPLINE)",
    "GATO 2 GAME AREA",
    "GATO 2 - 2 (MUD)",
    "GATO 3 - 1",
    "GATO 3 - 2",
    "GATO 3 - 3",
  ],
  "ZONE 3": [
    "NEWLAND 1 / TEMPLE RUN",
    "NEWLAND 2 / DUEL",
    "NEWLAND 3 / ATLANTIS",
    "JUNKYARD",
    "GEAR UP",
    "PIXEL",
    "CIRCUS",
    "SLIPPERRY",
    "STUNTSCHOOL",
    "SPEEDY",
    "IN BALL",
    "TWOWAYS",
    "SLIPPERY 2",
    "RIVER 1",
    "RIVER 2",
    "RIVER 4 GAME ZONE",
    "RIVER MINI GAME 1",
    "RIVER MINI GAME 2",
    "COLOSSEUM P1",
    "COLOSSEUM P2",
    "COLOSSEUM P3",
    "COLOSSEUM P4",
  ],
  "ZONE 4": [
    "PALMILLA FULLWATER",
    "PALMILLA WATER TO LAND",
    "PALMILLA 1",
    "PALMILLA JUNGLE RUN",
    "PALMILLA 3",
    "PALMILLA WATER",
    "PALMILLA LAND",
  ],
};
